import { render, staticRenderFns } from "./gateway.vue?vue&type=template&id=64ddc1c0"
import script from "./gateway.vue?vue&type=script&lang=js"
export * from "./gateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ddc1c0')) {
      api.createRecord('64ddc1c0', component.options)
    } else {
      api.reload('64ddc1c0', component.options)
    }
    module.hot.accept("./gateway.vue?vue&type=template&id=64ddc1c0", function () {
      api.rerender('64ddc1c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flowable/nodePanel/gateway.vue"
export default component.exports